import Http from '@/utils/http/index';

export default {
  /**
   * 获取商户余额
   */
  getAccountBalances(params) {
    return Http.get('/merchant/account/queryAccountBalances', { params });
  },
  /**
   * 获取商户可提现余额
   */
  getCollectBalance(params) {
    return Http.get('/collect/balance/list', { params });
  },
  /**
   * 账户变动明细
   */
  getAccountChangeDetail(params) {
    return Http.get('/merchant/account/queryAccountChangeDetail', { params });
  },

  /**
   * 统计 Balance 对应 VA 账户
   * @param {*} params
   * @returns
   */
  getVABalanceCount(params) {
    return Http.post('/merchantVaApply/count', params);
  },
};
